var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chart-block mb-5 px-3" },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 col-md-8" }, [
          _vm.ordinaryDisplay
            ? _c("h2", { staticClass: "font-weight-bold" }, [
                _vm._v(_vm._s(_vm.chart.title))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.noTownValue
            ? _c("h2", { staticClass: "font-weight-bold" }, [
                _vm._v(
                  "（" +
                    _vm._s(_vm.location.countyname) +
                    "之）" +
                    _vm._s(_vm.chart.title)
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-md-4" }, [
          !_vm.showTileImage
            ? _c(
                "button",
                { staticClass: "ts-btn h6", on: { click: _vm.downloadData } },
                [
                  _c("img", { attrs: { src: _vm.downloadPng } }),
                  _vm._v(" 下載資料(.CSV)\n\t\t\t")
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showAIButton
            ? _c(
                "button",
                {
                  staticClass: "ts-btn h6",
                  attrs: { disabled: _vm.isAIProcessing },
                  on: { click: _vm.sendDataForInsight }
                },
                [
                  _c("img", { attrs: { src: _vm.aiPng } }),
                  _vm._v(" AI 闡釋\n\t\t\t")
                ]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col" }, [
          _vm.showTilelistTitle(_vm.chart.id)
            ? _c("h1", [
                _c("img", {
                  staticClass: "add-btn",
                  attrs: { src: _vm.mapPng }
                }),
                _vm._v("：看疊圖　"),
                _c("img", {
                  staticClass: "add-btn",
                  attrs: { src: _vm.removePng }
                }),
                _vm._v("：清除疊圖")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showTileImage
            ? _c(
                "h2",
                [
                  _vm._v("－" + _vm._s(_vm.chart.title) + "\n\t\t\t"),
                  _vm.notOnlyOptUnsel
                    ? _c("img", {
                        staticClass: "add-btn",
                        attrs: { src: _vm.mapPng },
                        on: {
                          click: function($event) {
                            _vm.showTile()
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.group0.length != 0
                    ? _c("img", {
                        staticClass: "add-btn",
                        attrs: { src: _vm.removePng },
                        on: {
                          click: function($event) {
                            _vm.removeTiles()
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.chart.columns, function(column) {
                    return _vm.showTileImage
                      ? _c("h5", { staticClass: "tilelist" }, [
                          _vm.chart.columns.length > 1
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.group,
                                    expression: "group"
                                  }
                                ],
                                attrs: { id: _vm.chart.id, type: "checkbox" },
                                domProps: {
                                  value: column,
                                  checked: Array.isArray(_vm.group)
                                    ? _vm._i(_vm.group, column) > -1
                                    : _vm.group
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.group,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = column,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.group = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.group = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.group = $$c
                                    }
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.chart.columns.length > 1
                            ? _c("label", [
                                _vm._v(_vm._s(_vm.getTitle(column)))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.chart.columns.length == 1
                            ? _c("span", [
                                _vm._v(" ■ " + _vm._s(_vm.getTitle(column)))
                              ])
                            : _vm._e()
                        ])
                      : _vm._e()
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showButton
            ? _c("img", {
                staticClass: "chart-table-btn",
                attrs: { src: _vm.chartIcon, alt: "圖表" },
                on: {
                  mouseenter: function($event) {
                    _vm.chartIconHover = true
                  },
                  mouseout: function($event) {
                    _vm.chartIconHover = false
                  },
                  click: function($event) {
                    _vm.showChart = true
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showButton
            ? _c("img", {
                staticClass: "chart-table-btn",
                attrs: { src: _vm.tableIcon, alt: "表格" },
                on: {
                  mouseenter: function($event) {
                    _vm.tableIconHover = true
                  },
                  mouseout: function($event) {
                    _vm.tableIconHover = false
                  },
                  click: function($event) {
                    _vm.showChart = false
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showAdminComparison && !_vm.showTableOrTypeTable
            ? _c(
                "p",
                {
                  staticClass: "instruction",
                  staticStyle: { display: "inline-block" }
                },
                [_c("u", [_vm._v("點選圖例：鄉鎮對比縣市/全國資料")])]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showAdminComparison
            ? _c(
                "p",
                {
                  staticClass: "instruction",
                  staticStyle: { display: "inline-block" }
                },
                [_vm._v("；")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showMapInstruction
            ? _c(
                "p",
                {
                  staticClass: "instruction",
                  staticStyle: { display: "inline-block" }
                },
                [_c("u", [_vm._v("點選圖表資料：看地圖")])]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showTableOrTypeTable
            ? _c(
                "p",
                {
                  staticClass: "instruction",
                  staticStyle: { display: "inline-block" }
                },
                [
                  _c("u", [
                    _vm._v("點選"),
                    _c("img", {
                      staticClass: "add-btn",
                      attrs: { src: _vm.mapPng }
                    }),
                    _vm._v("：看地圖")
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showTableOrTypeTable && _vm.applyUserData
            ? _c(
                "p",
                {
                  staticClass: "instruction",
                  staticStyle: { display: "inline-block" }
                },
                [_vm._v("；")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showTableOrTypeTable && _vm.applyUserData
            ? _c(
                "p",
                {
                  staticClass: "instruction",
                  staticStyle: { display: "inline-block" }
                },
                [
                  _c("u", [
                    _vm._v("點選"),
                    _c("img", {
                      staticClass: "add-btn",
                      attrs: { src: _vm.addPng }
                    }),
                    _vm._v("：新增資料")
                  ])
                ]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm.showChart
        ? [
            _vm.chart.type === "line_chart"
              ? _c("LineChart", {
                  attrs: {
                    index: _vm.index,
                    chartdata: _vm.lineChartData,
                    chartcolumns: _vm.tableColumns,
                    categ: _vm.categ,
                    subcateg: _vm.subcateg,
                    location: this.location,
                    userColumnsData: _vm.userColumnsData
                  }
                })
              : _vm.chart.type === "pie_chart"
                ? _c("PieChart", {
                    attrs: {
                      chartdata: _vm.chartdata,
                      chartcolumns: _vm.tableColumns,
                      years: _vm.years,
                      categ: _vm.categ,
                      subcateg: _vm.subcateg,
                      userColumnsData: _vm.userColumnsData
                    }
                  })
                : _vm.chart.type === "treemap_chart"
                  ? _c("TreemapChart", { attrs: { chartdata: _vm.chartdata } })
                  : _vm.chart.type === "bar_chart"
                    ? _c("ColumnChart", {
                        attrs: {
                          chartdata: _vm.chartdata,
                          chartcolumns: _vm.tableColumns,
                          years: _vm.years,
                          categ: _vm.categ,
                          subcateg: _vm.subcateg,
                          userColumnsData: _vm.userColumnsData
                        }
                      })
                    : _vm.chart.type === "grp_bar_chart"
                      ? _c("GroupColumnChart", {
                          attrs: {
                            chartdata: _vm.groupColumnChartdata,
                            chartcolumns: _vm.tableColumns,
                            years: _vm.years,
                            categ: _vm.categ,
                            subcateg: _vm.subcateg
                          }
                        })
                      : _vm.chart.type === "pop_pyramid"
                        ? _c("PopulationPyramid", {
                            attrs: {
                              chartdata: _vm.popPyramidChartdata,
                              chartcolumns: _vm.tableColumns,
                              years: _vm.years,
                              categ: _vm.categ,
                              subcateg: _vm.subcateg
                            }
                          })
                        : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.showTableOrTypeTable
        ? _c(
            "div",
            { staticClass: "table-chart" },
            [
              _c("TesasTable", {
                attrs: {
                  tableColumns: _vm.tableColumns,
                  tableColumnsTitle: _vm.tableColumnsTitle,
                  columnClickables: _vm.columnClickables,
                  years: _vm.years,
                  categ: _vm.categ,
                  subcateg: _vm.subcateg,
                  location: this.location,
                  tableData: _vm.tableData,
                  applyUserData: _vm.applyUserData,
                  userColumnsData: _vm.userColumnsData
                },
                on: { "user-columns-changed": _vm.handleUserColumnsChanged }
              })
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }